/*
 * wishlist-datalayer.js
 * Pushuje event GA4 `add_to_wishlist` do window.dataLayer (format GTM ecommerce).
 *
 * Decoupled od rdzenia Ecomus (klasa Wishlist w custom.js):
 *  1. capture-phase click/keydown na <hdt-wishlist> — czytamy atrybut `action`
 *     ZANIM Ecomus go zmieni. Tylko action="add" oznacza intencję dodania.
 *  2. potwierdzenie przez istniejacy event `theme4:wishlist:update` — dziala dla
 *     obu trybow (localStorage sync oraz app fetch async). Push dopiero gdy
 *     przycisk faktycznie przeszedl w stan "added".
 *
 * Dane produktu (item_id = variant ID, cena, marka itd.) czytane z JSON-a
 * `<script type="application/json" data-ga4-wishlist>` osadzonego w karcie
 * Design 11 (snippets/card-product11.liquid). Poza Design 11 (brak JSON-a)
 * event sie NIE odpala — nie wysylamy niespojnego identyfikatora.
 */
(function () {
  'use strict';

  // Karta oczekujaca na potwierdzenie dodania (ustawiana przy kliknieciu "add").
  var pendingCard = null;

  function readPayload(card) {
    if (!card) return null;
    var node = card.querySelector('[data-ga4-wishlist]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  function toMajorUnits(cents) {
    var n = parseInt(cents, 10);
    if (isNaN(n)) return undefined;
    return Math.round(n) / 100;
  }

  function buildItem(data) {
    var item = {
      item_id: String(data.item_id == null ? '' : data.item_id),
      item_name: data.item_name || '',
      quantity: 1
    };
    if (data.item_brand) item.item_brand = data.item_brand;
    if (data.item_category) item.item_category = data.item_category;
    if (data.item_variant) item.item_variant = data.item_variant;
    if (data.legacy_gmc_id) item.legacy_gmc_id = data.legacy_gmc_id;

    var price = toMajorUnits(data.price_cents);
    if (price !== undefined) item.price = price;
    var discount = toMajorUnits(data.discount_cents);
    if (discount !== undefined) item.discount = discount;
    return item;
  }

  function pushEvent(data) {
    if (!data || data.item_id == null) return;
    var item = buildItem(data);

    window.dataLayer = window.dataLayer || [];
    // Czyszczenie poprzedniego stanu ecommerce — zalecane przez Google dla GTM.
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_wishlist',
      ecommerce: {
        currency: data.currency || undefined,
        value: item.price !== undefined ? item.price : undefined,
        items: [item]
      }
    });
  }

  function onAddIntent(e) {
    var target = e.target;
    var btn = target && target.closest ? target.closest('hdt-wishlist') : null;
    if (!btn) return;
    // Tylko "add" = intencja dodania. "added" (przejscie do listy) / "remove" pomijamy.
    if (btn.getAttribute('action') !== 'add') {
      pendingCard = null;
      return;
    }
    pendingCard = btn.closest('hdt-card-product');
  }

  document.addEventListener('click', onAddIntent, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') onAddIntent(e);
  }, true);

  // Potwierdzenie: po udanym dodaniu przycisk w karcie ma action="added".
  document.addEventListener('theme4:wishlist:update', function () {
    if (!pendingCard) return;
    var card = pendingCard;
    var btn = card.querySelector('hdt-wishlist');
    // Jesli add sie nie powiodl (np. blad fetch w trybie app), action zostaje "add" — nie pushujemy.
    if (!btn || btn.getAttribute('action') !== 'added') return;
    pendingCard = null;
    pushEvent(readPayload(card));
  });
})();
